import { Routes } from '@angular/router';
import { iframeGuard } from '@core/guards/iframe.guard';
import { riskManagerGuard } from '@core/guards/risk-manager.guard';
import { assessmentRoutes } from '@features/assessments/assessments.routes';
import { auditRoutes } from '@features/audit/audit.routes';
import { companyRoutes } from '@features/companies/companies.routes';
import { countrySectorAdviceRoutes } from '@features/country-sector/country-sector.routes';
import { HomeComponent } from '@features/home/home.component';
import { projectRoutes } from '@features/projects/projects.routes';
import { sectorRoutes } from '@features/sectors/sectors.routes';
import { treatyRoutes } from '@features/treaties/treaties.routes';
import { userGuideRoutes } from '@features/user-guides/user-guides.routes';
import { watchlistsRoutes } from '@features/watchlists/watchlists.routes';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [iframeGuard],
    children: [
      { path: '', component: HomeComponent },
      {
        path: 'insights-auth/callback',
        loadComponent: () =>
          import('@core/insights-auth-callback/insights-auth-callback.component').then(m => m.InsightsAuthCallbackComponent),
      },
      ...assessmentRoutes,
      ...treatyRoutes,
      ...watchlistsRoutes,
      ...userGuideRoutes,
      {
        path: 'managed-texts',
        loadComponent: () => import('@features/managed-texts/managed-texts.component').then(m => m.ManagedTextsComponent),
        canActivate: [riskManagerGuard],
      },
      ...sectorRoutes,
      ...projectRoutes,
      ...companyRoutes,
      ...countrySectorAdviceRoutes,
      ...auditRoutes,
      { path: '**', redirectTo: '' },
    ],
  },
];
